<template>
  <InputComponent v-bind="$attrs" class="field-tags">
    <template #after-label>
      <slot name="after-label"></slot>
    </template>
    <VueTagsInput
      v-model="tag"
      class="tags-input"
      :tags.sync="valueComp"
      :autocomplete-items="autocompleteItems"
      v-bind="$attrs"
      @tags-changed="$ev => $emit('tags-changed', $ev)"
    />
  </InputComponent>
</template>

<script>
import VueTagsInput, { createTags } from '@johmun/vue-tags-input'
import { Debounce } from '.././utils'
import InputComponent from '../components/Input.vue'
import { mergeDeepRight } from 'ramda'

async function Fetch(url, options = {}) {
  let defaultOptions = {
    headers: {
      Accept: 'application/json',
      'kvass-template-language': localStorage.getItem('lang'),
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }

  return fetch(url, mergeDeepRight(defaultOptions, options)).then(res => {
    if (!res.ok) throw res

    return res
  })
}

//transform item to string based on text or to {text} if toObject is true
function transformItem(item, options = {}) {
  const { toObject = false } = options

  let result = item

  let itemIsObject = true
  if (typeof item === 'string' || typeof item === 'number') itemIsObject = false

  if (toObject)
    result = itemIsObject
      ? {
          text: result.text,
          ...result,
        }
      : {
          text: result,
        }
  else {
    result = itemIsObject ? result.text : result
  }

  return result
}
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    autocomplete: [String, Array, Function],
    searchKey: {
      type: [String, Boolean],
      default: 'search',
    },
  },
  watch: {
    tag: {
      handler() {
        this.getAutocomplete()
      },
      immediate: true,
    },
  },
  data() {
    return {
      tag: '',
      fetchedAutocomplete: null,
    }
  },
  computed: {
    valueComp: {
      get() {
        if (!this.value) return
        return createTags(this.value)
      },

      set(val) {
        console.log(val.map(v => transformItem(v, { toObject: false })))
        this.$emit(
          'input',
          val.map(v => transformItem(v, { toObject: false })),
        )
      },
    },
    autocompleteItems() {
      if (this.fetchedAutocomplete) return this.fetchedAutocomplete
      if (this.autocomplete instanceof Array) return this.autocomplete

      return []
    },
  },
  methods: {
    getAutocomplete: Debounce(function () {
      const set = items =>
        //map items to simple
        (this.fetchedAutocomplete = items.map(i => transformItem(i, { toObject: true })))

      switch (typeof this.autocomplete) {
        case 'string':
          const url = new URL(
            this.autocomplete.match(/https?:\/\//)
              ? this.autocomplete
              : `${location.origin}${this.autocomplete}`,
          )
          if (this.tag && this.searchKey) url.searchParams.append(this.searchKey, this.tag)

          return Fetch(url.toString())
            .then(res => res.json())
            .then(items => {
              return Array.from(
                new Set(
                  items
                    .map(item => {
                      if (typeof item === 'string') return item
                      if (typeof item === 'object' && item.value) {
                        let text = item.value
                        if (text instanceof Array) {
                          return text.map(i => {
                            return {
                              text: i,
                              ...item,
                            }
                          })
                        }
                        return {
                          text,
                          ...item,
                        }
                      }
                      return item
                    })
                    .filter((value, index, array) => {
                      if (typeof value === 'string') return true
                      return index === array.findIndex(t => t.text === value.text)
                    })
                    .flat(Infinity),
                ),
              )
            })
            .then(items => {
              return items.filter(
                item =>
                  !this.tag ||
                  new RegExp(this.tag, 'i').test(transformItem(item, { toObject: false })),
              )
            })
            .then(items => set(items))
        case 'object':
          return
        case 'function':
          return this.autocomplete(this.tag).then(items => set(items))
      }
    }, 300),
  },
  components: {
    VueTagsInput,
    InputComponent,
  },
}
</script>

<style lang="scss">
.field-tags {
  .vue-tags-input {
    $tagPadding: 0.8rem;
    background: transparent !important;
    max-width: 100% !important;

    &.elder-input__element {
      padding: 0;

      .ti-input {
        border: none;
      }
    }

    .ti {
      &-input {
        padding: $tagPadding !important;
        border: none !important;
      }

      &-tag {
        color: black !important;
        background-color: #f2f2f2 !important;
        border-radius: var(--border-radius) !important;
        padding: 4.75px 4px 4.75px 8px;
        font: inherit;
      }

      &-icon-close {
        margin-left: 5px;
        opacity: 0.5;
        transition: opacity 150ms ease;

        &:hover {
          opacity: 1;
        }
      }

      &-new-tag-input-wrapper {
        font-size: 1em !important;
        font: inherit;
        color: inherit;
      }

      &-item > div {
        padding: 0.5rem $tagPadding;
        border-radius: var(--border-radius) !important;
      }

      &-autocomplete {
        color: black !important;
        border-color: var(--border-color) !important;
        border-top: none !important;
        box-shadow: $box-shadow;
      }

      &-selected-item {
        background-color: css-alpha('primary', 0.1) !important;
        color: black !important;
      }
    }
  }
}
</style>
